import { DEFAULT_CRS } from "@evergis/react";
import { Map } from "@evergis/sgis/es/Map";
import { TileScheme } from "@evergis/sgis/es/TileScheme";

const createMapLevels = () => {
  const defaultLevels = [
    {
      // https://www.maptiler.com/google-maps-coordinates-tile-bounds-projection/#22/48.10/-22.32
      // Meters / pixel for zoom lvl 0
      resolution: 156543.03392800014,
      indexCount: 1,
      zIndex: 0,
    },
  ];

  for (let i = 1; i < 23; i++) {
    defaultLevels[i] = {
      resolution: defaultLevels[i - 1].resolution / 2,
      indexCount: defaultLevels[i - 1].indexCount * 2,
      zIndex: i,
    };
  }

  return defaultLevels;
};

const createTileScheme = () =>
  new TileScheme({
    // https://www.maptiler.com/google-maps-coordinates-tile-bounds-projection/#22/48.10/-22.32
    // Earth center coordinates in mercator
    origin: [-20037508.342787, 20037508.342787],
    levels: createMapLevels(),
    tileWidth: 256,
    tileHeight: 256,
    reversedY: false,
    limits: [-Infinity, -20037508.342787, Infinity, 20037508.342787],
  });

export const createMap = () =>
  new Map({
    crs: DEFAULT_CRS,
    tileScheme: createTileScheme(),
  });

export const map = createMap();
